import { MODALS } from '../actions/modals';

const levels = [
  'info', // 0
  'primary', // 1
  'success', // 2
  'warning', // 3
  'danger', // 4
];

const defaultState = {
  list: [],
};

export default (state = defaultState, { type, ...action }) => {
  switch (type) {
    case MODALS.ADD: // add to the end of queue
      return {
        ...state,
        list: state.list.concat([{
          ...action,
          level: levels[action.level],
          show: true,
        }]),
      };

    case MODALS.HIDE: // hide first
      return {
        ...state,
        list: state.list.map((item, i) => (i ? item : { ...item, title: false, download: false, show: false })),
      };

    case MODALS.REMOVE: // remove first
      return { ...state, list: state.list.filter((item, i) => i) };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/modals.js